import { render, staticRenderFns } from "./SidebarSlItem.vue?vue&type=template&id=5d81babd&"
import script from "./SidebarSlItem.vue?vue&type=script&lang=js&"
export * from "./SidebarSlItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSlItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports